import { defineStore } from "pinia";
import { ref } from "vue";
import { IFXCreatePaymentResponse } from "@esenda/core-ui/interfaces";

// TODO move in core-ui after branding changes are done
export interface IFXPrepareForBankTransferResponse {
    orderId: string; //The ID of the order created for the payment.
    paymentReference: string;
    sortCode?: string;
    accountNumber?: string;
    accountHolderName: string;
    iban?: string;
    bic?: string;
    returnUrl?: string; //Partner return URL
    quoteExpiryDate?: string;
    quoteRate?: string;
    amountInBaseCurrency: string;
    baseCurrency: string;
    amountInLocalCurrency?: string;
    localCurrency?: string;
}
// end of TODO

/**
 * IFX store to manage IFX payment-related data such as payment information.
 * The store persists data in sessionStorage to maintain state across page
 * reloads within the same session.
 */
export const useIFXStore = defineStore(
    "ifx",
    () => {
        // ── State ──────────────────────────────────────────────────────────────
        const ifxPaymentInformation = ref<IFXCreatePaymentResponse | null>(
            null,
        );
        const ifxBankTransferInformation =
            ref<IFXPrepareForBankTransferResponse | null>(null);

        // ── Actions ────────────────────────────────────────────────────────────
        function setIFXPaymentInformation(
            information: IFXCreatePaymentResponse | null,
        ) {
            ifxPaymentInformation.value = information;
        }

        function setIFXBankTransferInformation(
            information: IFXPrepareForBankTransferResponse | null,
        ) {
            ifxBankTransferInformation.value = information;
        }

        return {
            ifxPaymentInformation,
            setIFXPaymentInformation,
            ifxBankTransferInformation,
            setIFXBankTransferInformation,
        };
    },
    {
        persist: {
            pick: ["ifxPaymentInformation", "ifxBankTransferInformation"],
            storage: sessionStorage,
        },
    },
);
